import { UTM_PARAMS } from "../conf";
import getBrandUTMType from "./getBrandUTMType";

const getBrandUTMFlags = ({ brand, upsell = false } = {}) => {
	const utmType = getBrandUTMType({ brand, upsell });
	if (!brand?.utm || !utmType) {
		return {};
	}
	return brand.utm
		.filter((flag) => flag.param_type === utmType)
		.reduce((flags, flag) => {
			return {
				...flags,
				[UTM_PARAMS[flag.param_name - 1]]: flag.param_value,
			};
		}, {});
};

export default getBrandUTMFlags;
